import { Injectable, NgZone, Renderer2 } from '@angular/core';
import { BehaviorSubject, fromEvent, interval, Observable, ReplaySubject } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
import { isMobile, log } from '../functions';
import { Chat, IMessengerConnector, Message, MessageUser, Profile } from '../types/all.type';
import { CloseContextMenuEvent, IContextMenuClickEvent } from 'ngx-contextmenu';
import { document } from 'ngx-bootstrap/utils';
import { ModalService } from './modal.service';
import { NotifierWrapService } from './notifier-wrap.service';
import { Editor } from 'ngx-editor';
import { Router } from "@angular/router";

declare var ym: any;

@Injectable({
  providedIn: 'any'
})

export class InterfaceService {
  public clearTextArea$: ReplaySubject<void> = new ReplaySubject();
  public logout$: ReplaySubject<IMessengerConnector | void> = new ReplaySubject();
  public toggleChatPine$: ReplaySubject<Chat> = new ReplaySubject();
  public reLoadChats$: ReplaySubject<void> = new ReplaySubject();
  public reLoadChatsForce$: ReplaySubject<void> = new ReplaySubject();
  messageTextareaType: 'editor' | 'text' = 'editor';
  private lastNotify: string;
  public supportEmoji = true;
  readHistory$: ReplaySubject<void> = new ReplaySubject();
  public setTheme$: ReplaySubject<string> = new ReplaySubject();
  public detectChangesConnect$: ReplaySubject<void> = new ReplaySubject();
  public searchToggle$: ReplaySubject<boolean> = new ReplaySubject();
  public focusTextArea$: ReplaySubject<boolean> = new ReplaySubject();
  public scrollChat$: ReplaySubject<void> = new ReplaySubject();
  public positionTextArea$: ReplaySubject<number> = new ReplaySubject();
  public isCloseChat$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  public openChat$: ReplaySubject<any> = new ReplaySubject();
  public detectChanges$: ReplaySubject<string> = new ReplaySubject();
  public showDetail$: ReplaySubject<string | number | false> = new ReplaySubject();
  public scrollToMessage$: ReplaySubject<Message> = new ReplaySubject();
  public showDetailInfo: string | number;

  public showTabsInput$: ReplaySubject<boolean | 'toggle'> = new ReplaySubject();
  public initTabsInput = false;
  public showTabsInput = false;
  public thumbResize$: ReplaySubject<void> = new ReplaySubject();
  public showSidebar$: ReplaySubject<boolean> = new ReplaySubject();
  public resizeObservable$: Observable<any>;
  public openDropdown$: BehaviorSubject<Message | Chat> = new BehaviorSubject(undefined);
  public openGrafana$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public isShowTextarea$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public _supportsEmoji: any = true;
  public behavior: 'smooth' | false = 'smooth';
  public $onEdtMessage: ReplaySubject<string> = new ReplaySubject();
  public $onCancelEdtMessage: ReplaySubject<void> = new ReplaySubject();
  public $onCancelAddSender: ReplaySubject<void> = new ReplaySubject();
  public _showMobileHome: boolean;

  public isMessageInputAnimate = true;
  public editor: Editor;
  public filterType: 'private' | 'group' | '' = '';
  public profileSetService$: ReplaySubject<void> = new ReplaySubject();
  public errorsCount = 0;

  constructor(
    public router: Router,
    public notifierWrapService: NotifierWrapService,
    public modalService: ModalService,
    private zone: NgZone,
  ) {
    /*if (this.isTelesellerDomain && !this.isLeadsDomain) {
      alert('Телеграм начал очень активно блокировать аккаунты, мы работаем над решением но о сроках сказать нечего. При успехе мы уведомим на почту.');
    }*/
    if (window.outerWidth <= 360 && this.isFocused()) {
      alert('Экран вашего устройства очень маленький, рекомендуем сменить устройство.');
    }
    this._supportsEmoji = this.supportsEmoji();
    // this.renderer = this._renderer.createRenderer(null, null);
    try {
      document.body.style.zoom = '100%';
    } catch (e) {
    }
    this.showTabsInput$.subscribe((val) => {
      if (val === 'toggle') {
        this.showTabsInput = !this.showTabsInput;
      } else {
        this.showTabsInput = val;
      }
      if (val) {
        this.initTabsInput = true;
        this.showDetail$.next(false);
      } else {
        this.thumbResize$.next();
        this.showSidebar$.next(this.showSidebar);
      }
    });
    this.openChat$.subscribe(() => {
      this.openGrafana$.next(false);
      this.openDropdown$.next(undefined);
      this.router.navigateByUrl('/ui');
    });
    this.showDetail$.subscribe((id) => {
      this.openDropdown$.next(undefined);
      this.showSidebar$.next(this.showSidebar);
      this.thumbResize$.next();
      if ((this.showDetailInfo && this.showDetailInfo === id) || !id) {
        delete this.showDetailInfo;
      } else if (id) {
        this.showDetailInfo = id;
      }
    });

    this.zone.runOutsideAngular(() => {
      this.resizeObservable$ = fromEvent(window, 'resize').pipe(debounceTime(200)); // , tag("resizeObservable$")
      this.resizeObservable$.subscribe(() => {
        this.openDropdown$.next(undefined);
        this.thumbResize$.next();
        this.setHeightApp();
      });
    });
    this.setHeightApp();
    if (this.isTelesellerDomain) {
      this.setThemeColor('telegram');
    }
  }

  get showSidebar(): boolean {
    return !!this.showDetailInfo || this.showTabsInput;
  }

  setPropertyCss(prop, val) {
    if (val) {
      document.documentElement.style.setProperty(`--${prop}`, val);
    }
  }

  setHeightApp(): void {
    //////////
    let vh = window.innerHeight;
    let vhAll = window.innerHeight;
    /// Set init height
    if (window.innerWidth >= 1000) {
      this.setPropertyCss('vh', (vh * 0.9) + 'px');
    } else {
      this.setPropertyCss('vh', vh + 'px');
    }
    this.setPropertyCss('content-height', vh + 'px');
    /// Set calc height
    if (window.innerWidth >= 1000) {
      vh = document.getElementsByClassName('app-root')[0]?.clientHeight;
      vhAll = document.documentElement.clientHeight;
    }
    this.setPropertyCss('content-height', vhAll + 'px');
    if (vh) {
      this.setPropertyCss('vh', vh + 'px');
    }
    log('setHeightApp: ' + vh);
  }

  getChatTitle(chat: Chat, user: MessageUser | Profile | {} = {}, isLoaded = true) {
    if (chat.isSelf) {
      return 'Избранное';
    }
    let title = '';
    if (chat?.name?.first) {
      title = (chat?.name?.first || chat?.username) + ' ' + chat?.name?.last;
    } else {
      title = chat?.title || chat?.username || title;
    }
    if (!title) {
      title = isLoaded ? 'Удаленный аккаунт' : '';
    }
    return title;
  }

  contextMenuOpenEvent($event: IContextMenuClickEvent, component: string) {
    $event.item.component = component;
    this.openDropdown$.next($event.item);
    this.behavior = false;

    const overlay = document.getElementsByClassName('cdk-overlay-container')[0] as HTMLElement;
    overlay?.classList?.remove('hidden');

    if (component === 'messages-scroll') {
      this.scrollToMessage$.next($event.item);
      setTimeout(() => {
        this.behavior = 'smooth';
      }, 1000);
      const contextMenuHtml = document.getElementsByClassName('ngx-contextmenu')[0] as HTMLDivElement;
      // const viewPortHtml = <HTMLDivElement>document.getElementsByClassName('viewport')[0];
      contextMenuHtml.style.display = 'none';
      setTimeout(() => {
        const messageHtml = document.getElementById('message-' + $event.item.id)
          ?.getElementsByClassName('message-content')[0] as HTMLElement;
        if (messageHtml) {
          const setPosition = () => {
            const offset = messageHtml.getBoundingClientRect();
            let top = (offset.y + offset.height + 10);
            if (!isMobile()) {
              contextMenuHtml.style.setProperty('left', offset.x + 'px', 'important');
            } else {
              if (window.outerHeight - top < contextMenuHtml.offsetHeight) {
                top = window.outerHeight - contextMenuHtml.offsetHeight;
              }
              contextMenuHtml.style.setProperty('left', '0px', 'important');
            }
            contextMenuHtml.style.setProperty('top', top + 'px', 'important');
          };
          setPosition();
          interval(200).pipe(take(10)).subscribe(() => {
            setPosition();
          });
          if (!isMobile()) {
            contextMenuHtml.classList.add('showEffectUp');
          }
          contextMenuHtml.style.display = '';
        } else {
          contextMenuHtml.style.display = '';
        }
        this.detectChanges$.next('messages-scroll');
        // this.detectChanges$.next('chat-list');

      }, 500);
    }
  }

  contextMenuCloseEvent($event: CloseContextMenuEvent) {
    log('contextMenuCloseEvent');
    this.openDropdown$.next(undefined);
    setTimeout(() => {
      this.detectChanges$.next('messages-scroll');
      // this.detectChanges$.next('chat-list');
      // TODO перенести на событие без таййаута, что бы норм убирался эффект замыливания
    }, 500);
  }

  resize(): void {
    window.dispatchEvent(new Event('resize'));
  }

  public setThemeColor(type: string): void {
    this.setTheme$.next(type);
    // TODO перенести в классы цвета

    let themeColor = '#00959c';
    switch (type) {
      case 'telegram':
        themeColor = '#2B85F2';
        break;
      case 'vk':
        themeColor = '#4c75a3';
        break;
      case 'whatsapp':
        themeColor = '#00a884';
        break;
      case 'skype':
        themeColor = '#00aff0';
        break;
      case 'fellowdesk':
        themeColor = '#E96D1F';
        break;
    }
    document.documentElement.style.setProperty('--theme-color', themeColor);
  }

  supportsEmoji(): boolean {
    const ctx = document.createElement('canvas').getContext('2d');
    ctx.canvas.width = ctx.canvas.height = 1;
    ctx.fillText('😗', -4, 4);
    return ctx.getImageData(0, 0, 1, 1).data[3] > 0; // Not a transparent pixel
  }

  textErrorHandling(error: string, isNotify = true): string | void {
    const errors = {
      AUTH_KEY_DUPLICATED: 'Ключ авторизации уже используется',
      AUTH_KEY_INVALID: 'Неверный ключ авторизации',
      AUTH_KEY_PERM_EMPTY: 'Ключ авторизации отсутствует',
      AUTH_TOKEN_EXPIRED: 'Истек срок действия токена авторизации',
      AUTH_TOKEN_INVALID: 'Недействительный токен авторизации',
      FILE_ID_INVALID: 'Недопустимый идентификатор файла',
      FILE_PARTS_INVALID: 'Недопустимое количество частей файла',
      FILE_PART_X_INVALID: 'Недопустимая часть файла',
      FILE_REFERENCE_EMPTY: 'Ссылка на файл не может быть пустой',
      FILE_REFERENCE_EXPIRED: 'Ссылка на файл истекла',
      INPUT_CONSTRUCTOR_INVALID: 'Недопустимый конструктор ввода',
      INPUT_METHOD_INVALID: 'Недопустимый метод ввода',
      INPUT_USER_DEACTIVATED: 'Пользователь деактивирован',
      MESSAGE_EMPTY: 'Сообщение не может быть пустым',
      MSG_ID_INVALID: 'Недопустимый идентификатор сообщения',
      MSG_WAIT_FAILED: 'Не удалось отправить сообщение',
      MSG_TOO_LONG: 'Сообщение слишком длинное',
      NOT_FOUND: 'Не найдено',
      PEER_FLOOD: 'Слишком много запросов на этот чат',
      PEER_ID_INVALID: 'Чат не найден',
      QUERY_TOO_SHORT: 'Запрос слишком короткий',
      USERNAME_NOT_MODIFIED: 'Имя пользователя не изменено',
      USERNAME_OCCUPIED: 'Имя пользователя занято',
      USERNAME_INVALID: 'Недопустимое имя пользователя',
      SESSION_REVOKED: 'Сессия отозвана',
      TAKEOUT_INIT_DELAYED: 'Запрос на экспорт данных обрабатывается',
      TAKEOUT_INVALID_REQUEST: 'Неверный запрос на экспорт данных',
      VIDEO_FILE_INVALID: 'Недопустимый файл видео',
      WEBPAGE_CURL_FAILED: 'Не удалось получить содержимое веб-страницы',
      PHONE_NUMBER_INVALID: 'Некорректный номер телефона',
      PHONE_CODE_INVALID: 'Некорректный код из СМС',
      PHONE_NUMBER_UNOCCUPIED: 'Номер телефона не зарегистрирован в Telegram',
      PHONE_NUMBER_BANNED: 'Номер телефона заблокирован в Telegram',
      PHONE_NUMBER_FLOOD: 'Слишком много запросов на этот номер телефона',
      PHONE_PASSWORD_PROTECTED: 'Аккаунт защищен паролем',
      PHONE_NUMBER_OCCUPIED: 'Номер телефона уже зарегистрирован в Telegram',
      PASSWORD_HASH_INVALID: 'Недопустимый хэш пароля',
      PASSWORD_EMPTY: 'Пароль не может быть пустым',
      PASSWORD_TOO_FRESH: 'Нельзя задать пароль, пока аккаунт еще новый',
      CONNECTION_API_ID_INVALID: 'Неверный идентификатор приложения',
      CONNECTION_DEVICE_MODEL_EMPTY: 'Не указана модель устройства',
      CONNECTION_LANG_PACK_INVALID: 'Недопустимый языковой пакет',
      CONNECTION_LAYER_INVALID: 'Недопустимая версия протокола MTProto',
      CONNECTION_NOT_INITED: 'Не инициализировано соединение с сервером',
      CONNECTION_SYSTEM_EMPTY: 'Не указана операционная система устройства',
      PHONE_CODE_EMPTY: 'Не указан код подтверждения',
      PHONE_CODE_EXPIRED: 'Код подтверждения устарел',
      PHONE_CODE_HASH_EMPTY: 'Не указан хэш кода подтверждения',
      PHONE_NUMBER_APP_SIGNUP_FORBIDDEN: 'Невозможно зарегистрировать аккаунт с помощью приложения',
      SESSION_PASSWORD_NEEDED: 'Необходимо ввести пароль сеанса',
      TIMEOUT: 'Время ожидания истекло',
      TWO_FACTOR_DISABLED: 'Двухфакторная аутентификация отключена',
      TWO_FACTOR_EMAIL_MISSING: 'Необходимо указать email для включения двухфакторной аутентификации',
      TWO_FACTOR_INVALID_CODE: 'Неверный код двухфакторной аутентификации',
      TWO_FACTOR_REQUIRED: 'Требуется двухфакторная аутентификация',
      USER_BANNED: 'Пользователь заблокирован',
      USER_DEACTIVATED: 'Пользователь деактивирован',
      USER_INVALID: 'Неверный пользователь',
      PASSWORD_INVALID: 'Неверный пароль',
      PASSWORD_REQUIRED: 'Требуется пароль',
      PHONE_PASSWORD_FLOOD: 'Слишком много запросов на ввод пароля',
      PHONE_PASSWORD_REQUIRED: 'Требуется пароль',
      FLOOD_WAIT_X_SECONDS: 'Слишком много запросов, попробуйте снова через %s секунд(ы)',
      INTERNAL: 'Внутренняя ошибка сервера',
      UNKNOWN: 'Неизвестная ошибка',
      PHOTO_CROP_SIZE_SMALL: 'Фото слишком маленькое',
      ALBUM_PHOTOS_TOO_MANY: 'Вы загрузили слишком много фотографий профиля, удалите некоторые из них перед повторной попыткой',
      IMAGE_PROCESS_FAILED: 'Сбой при обработке изображения',
      PHOTO_CROP_FILE_MISSING: 'Отсутствует файл обрезки фотографий',
      PHOTO_EXT_INVALID: 'Недопустимое расширение фотографии',
      PHOTO_FILE_MISSING: 'Отсутствует файл с фотографией профиля',
      PHOTO_INVALID: 'Фотография недействительна'
    };
    for (const code in errors) {
      if (error.includes(code)) {
        return errors[code];
      }
    }
    return 'Неизвестная ошибка';
  }

  // Отработка ошибок, для вызовов запросов без подписки
  errorHandling(error: string | any, isNotify = true, Service: IMessengerConnector | false = false): string | undefined {
    this.errorsCount++;
    log('error', error, isNotify);
    let errorText = '';
    if (typeof error === 'string') {
      errorText = this.textErrorHandling(error, isNotify) || '';
    } else {
      if (error?.type === 'skip') {
        return;
      }

      switch (error?.status) {
        case 401:
          errorText = 'Один из аккаунтов был разлогинен, напишите нам, если считаете это ошибкой.';
          if (Service) {
            this.logout$.next(Service);
          } else {
            this.logout$.next();
          }
          break;
        case 408:
          errorText = 'Слишком много похожих запросов. Подождите...';
          break;
        case 304:
          errorText = 'Не изменилось.';
          break;
        case 404:
          errorText = 'Элемент не найден.';
          break;
        case 400:
          errorText = 'Ошибка запроса, обратитесь в техподдержку.';
          break;
        case 403:
          errorText = 'Доступ запрещен.';
          break;
        case 405:
          errorText = 'Доступ запрещен.';
          break;
        case 500:
          errorText = 'Произошла ошибка на сервере, попробуйте позже или обратитесь в техподдержку.';
          break;
        case 0:
          errorText = 'Сервис временно недоступен, попробуйте позже или обратитесь в техподдержку.';
          break;
        default:
          console.error('errorHandling default', error);
          errorText = 'Неизвестная ошибка, попробуйте позже или обратитесь в техподдержку, проверьте интернет или отключите VPN';
      }
    }
    if (error?.name === 'TimeoutError') {
      errorText  = 'Таймаут подключения, проверьте интернет';
    }
    const notify = error?.error?.detail?.message || error?.error?.detail || error?.error?.error_msg || errorText;
    if (isNotify && (this.lastNotify !== notify || error?.error?.detail?.error_id === 'PEER_FLOOD')) {
      this.notifierWrapService.notify('error', notify);
      this.lastNotify = notify;
    } else {
      return notify;
    }
  }

  public set showMobileHome(val) {
    this._showMobileHome = val;
    this.detectChanges$.next('chat-show');
  }

  addAccount(Service: IMessengerConnector) {
    this.modalService.openModal('ModalAddAccountComponent', {Service});
    this.showMobileHome = false;
  }

  public detectChangeForNotify(): void {
    setTimeout(() => {
      this.detectChanges$.next('app-root');
      this.detectChanges$.next('page-start');
    }, 100);
  }

  public isFocused() {
    return document.hasFocus();
  }

  get isTelesellerDomain(): boolean {
    return location.host === 'messenger.teleseller.ru' || this.isLeadsDomain;
  }
  get isLeadsDomain(): boolean {
    return location.host === 'localhost:4321' || location.host === 'leads.teleseller.ru' || location.host === 'chat.teleseller.ru';
  }

  /// UNIVERSAL EVENT FUNCTION
  goToEvent(eventName) {
    console.log('EVENT_NAME: "' + eventName + '"');
    try {
      ym(104137219, 'reachGoal', eventName);
    } catch (e) {
      console.log('EVENT_YANDEX_ERROR: "' + eventName + '"');
    }
  }

  setFullSize(renderer: Renderer2, isFull = true) {
    if (isFull) {
      renderer.addClass(document.body, 'full');
    } else {
      renderer.removeClass(document.body, 'full');
    }
  }

}
